module.exports = __webpack_public_path__ + "static/img/time-money.e066e17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/time-money.png
// module id = bMrs
// module chunks = 1